export const SalesQuote = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_300_3707)">
      <path
        d="M14 1.75C14 0.785167 13.2148 0 12.25 0H3.79167C2.66583 0 1.75 0.915833 1.75 2.04167V4.66667H2.91667V2.04167C2.91667 1.55925 3.30925 1.16667 3.79167 1.16667C4.27408 1.16667 4.66667 1.55925 4.66667 2.04167V3.5H11.0833V12.25C11.0833 12.5714 10.8214 12.8333 10.5 12.8333H7.58333V14H10.5C11.4648 14 12.25 13.2148 12.25 12.25V3.5H14V1.75ZM12.8333 2.33333H5.83333V2.04167C5.83333 1.72842 5.76217 1.43208 5.63617 1.16667H12.25C12.5714 1.16667 12.8333 1.42858 12.8333 1.75V2.33333ZM4.95833 5.83333H1.45833C0.6545 5.83333 0 6.48783 0 7.29167V14H6.41667V7.29167C6.41667 6.48783 5.76217 5.83333 4.95833 5.83333ZM5.25 12.8333H1.16667V7.29167C1.16667 7.13067 1.29733 7 1.45833 7H4.95833C5.11933 7 5.25 7.13067 5.25 7.29167V12.8333ZM1.75 7.58333H4.66667V8.75H1.75V7.58333ZM3.5 9.33333H4.66667V10.5H3.5V9.33333ZM1.75 9.33333H2.91667V10.5H1.75V9.33333ZM3.5 11.0833H4.66667V12.25H3.5V11.0833ZM1.75 11.0833H2.91667V12.25H1.75V11.0833Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_300_3707">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
